module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "35%",
      "title": "Saved Profile Filters",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "optin-table",
      "data": _vm.queries
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "width": "250",
      "label": "Title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "insertedAt",
      "width": "180",
      "label": "Date Created"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.inserted_at, 'lll')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Actions",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popconfirm', {
          attrs: {
            "confirm-button-text": "Yes, I'm sure",
            "cancel-button-text": "Cancel",
            "icon": "el-icon-info",
            "icon-color": "red",
            "title": "Are you want to apply this filter?"
          },
          on: {
            "onConfirm": function($event) {
              return _vm.handleApply(scope.row)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "size": "mini"
          },
          slot: "reference"
        }, [_vm._v("Apply")])], 1), _vm._v(" "), _c('el-popconfirm', {
          attrs: {
            "confirm-button-text": "Yes, Delete",
            "cancel-button-text": "Cancel",
            "icon": "el-icon-info",
            "icon-color": "red",
            "title": "Are you sure to delete this filter?"
          },
          on: {
            "onConfirm": function($event) {
              return _vm.handleDelete(scope.row)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "danger",
            "size": "mini"
          },
          slot: "reference"
        }, [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65565d1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/SavedQueryList.vue
// module id = 3310
// module chunks = 3